import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import HeaderPage from "./HeaderPage";
import { useNavigate } from "react-router-dom";
import bharat_voice from "../assets/images/BharatAudioLive.png";
import madeinBharat from "../assets/images/madeinBharatLogo.png";
import { Hash } from "phosphor-react";
import poster from "../assets/images/pm_poster.jpg";

const DEBUG = true;
const LIVE_ENDPOINT = "https://translationapi1.aicte-india.org";
const LOCALHOST_ENDPOINT = "http://localhost:9000"; // For testing
const endpoint = DEBUG ? LOCALHOST_ENDPOINT : LIVE_ENDPOINT;

// async function getSessionId() {
//   const url = `${endpoint}/generate-session-id`;
//   const response = await fetch(url);
//   const data = await response.json();
//   return data.session_id;
// }

// generate a random session ID
function getSessionId() {
  const segmentLength = 4;
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const generateSegment = () => {
    let segment = "";
    for (let i = 0; i < segmentLength; i++) {
      segment += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return segment;
  };

  return `${generateSegment()}-${generateSegment()}-${generateSegment()}`;
}
function extractCodeFromUrl(url) {
  console.log("extractCodeFromUrl", url);
  const parts = url.split("/");
  return parts[parts.length - 1];
}

function CreateSession() {
  const [sessionId, setSessionId] = useState("");
  const navigate = useNavigate();

  const handleSessionIdChange = (e) => {
    const inputValue = extractCodeFromUrl(e.target.value);
    setSessionId(inputValue);
  };

  const handleJoinSession = () => {
    if (!sessionId) {
      alert("Please enter a session ID");
      return;
    }
    const url = `/realtimeVoice/join/${sessionId}`;
    navigate(url);
    console.log("Join session", url);
  };

  function handleCreateSession(e) {
    const sessionId = getSessionId();
    setSessionId(sessionId);
    const url = `/realtimeVoice/create/${sessionId}`;
    navigate(url);
  }
  return (
    <>
      <HeaderPage />
      <img
        src={poster}
        alt="poster"
        style={{
          width: "100%",
        }}
      />
      <div className="sessionDiv">
        <Container className="pt-2">
          <div
            className="sesnLogoDiv cntnrLogo"
            style={{
              display: "flex",
              alignContent: "flex-start",
              justifyContent: "center",
            }}
          >
            <img src={bharat_voice} style={{ height: "14vh" }} alt="logo" />{" "}
            <img
              className="madeInBhrt"
              src={madeinBharat}
              style={{ height: "10vh" }}
              alt="logo"
            />
          </div>
          <div className="videoSldrCnt">
            <h2>Bharat Audio Live: Voice Uniting Bharat</h2>
            <p>
              Bharat Audio Live is a digital marvel, a platform where languages
              don't divide but unite, where voices traverse the expanse of this
              vast country, seamlessly weaving through its many tongues.{" "}
            </p>
            <p>
              Imagine a fisherman in the serene backwaters of Andhra pradesh.
              His native Telugu rolls off his tongue, rich and melodious. But
              today, he speaks not just to his usual comrades but to an audience
              in Punjab. As his voice travels through Bharat Audio Live, it
              transforms, emerging in fluent Punjabi. A farmer in the golden
              wheat fields of Punjab listens intently, his smartphone a window
              to this shared experience, transcending miles and languages.
            </p>
            <p>
              In the bustling streets of Kolkata, a Bengali poet recites her
              latest work. Her words, steeped in emotion, flow through Bharat
              Audio Live, reaching a young Rajasthani artist in the deserts of
              Jaisalmer. As the poetry finds its voice in Rajasthani, the
              artist's brush strokes begin to dance, inspired by words that were
              once foreign, now familiar and understood.
            </p>
            <p>
              Bharat Audio Live isn't just a technological marvel; it's a
              cultural tapestry. It brings together the Tamil entrepreneur,
              sharing business insights with budding Gujarati businessmen; the
              Marathi professor, whose lectures on history captivate students in
              Telugu-speaking Andhra Pradesh; the Kashmiri storyteller, whose
              tales enthrall listeners in the far south.
            </p>
            <p>
              The platform's transcript feature adds another layer of
              connection. Not just heard, these conversations are also seen,
              words flowing across screens in multiple languages, ensuring that
              every nuance, every emotion, is captured and understood. It's a
              tool for the deaf, an aid for the learner, a gift for the curious.
            </p>
            <p>
              As night falls over the Indian subcontinent, Bharat Audio Live
              continues its dance of languages. It's more than an app; it's a
              celebration of diversity, a testament to unity in variety. In a
              land of over a billion voices, each one finds a place, a listener,
              a friend in Bharat Audio Live. It's where every voice matters,
              every story is heard, and every word builds bridges.
            </p>
            <p>
              "Bharat Audio Live" is creatively presented, capturing the essence
              of diversity and connectivity in India.
            </p>
          </div>
          <Row className="justify-content-md-center">
            <Col md={12}>
              <div className="text-center mb-3">
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={handleCreateSession}
                >
                  Create Session
                </Button>
              </div>
              <Form className="sessnFormDiv">
                <Form.Group controlId="sessionId">
                  <Form.Label>Session ID</Form.Label>
                  <div className="inptdivnew">
                    <div className="sessnIdInpt">
                      <Form.Control
                        type="text"
                        placeholder="Enter session ID"
                        onChange={handleSessionIdChange}
                        onPaste={handleSessionIdChange}
                        onInput={handleSessionIdChange}
                        value={sessionId}
                        className="form-control me-2"
                      />
                      <span className="inptIcn">
                        <Hash size={32} />
                      </span>
                    </div>
                    <div className="joinSessnDiv">
                      <Button
                        variant="primary"
                        className="flex-grow px-4 py-2 mt-2 joinSessnBtn"
                        onClick={handleJoinSession}
                      >
                        Join Session
                      </Button>
                    </div>
                  </div>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CreateSession;
